<div class="">
  <div class="min-h-screen">
    <router-outlet></router-outlet>
  </div>

  <app-block-list [blockIdList]="footer()"></app-block-list>
</div>

<app-block-list [blockIdList]="globalFeatures()"></app-block-list>
